import React from 'react';
import styled from 'styled-components';

const AnimatedTextWrapper = styled.div`
  font-family: 'Nunito Sans';
  margin-top: 115px;
  div {
    position: relative;
    color: rgba(0, 0, 0, 0.3);
    font-size: 1em;
  }
  div:before {
    content: attr(data-text);
    position: absolute;
    overflow: hidden;
    max-width: 12em;
    white-space: nowrap;
    color: #37a3bc;
    animation: loading 2s linear infinite;
  }
  @keyframes loading {
    0% {
      max-width: 0;
    }
  }
`;

const AnimatedText = (props) => (
  <AnimatedTextWrapper className={props.className}>
    <div data-text={props.loadingText}>{props.loadingText}</div>
  </AnimatedTextWrapper>
);

export { AnimatedText };
